module.exports = __webpack_public_path__ + "static/media/grid-item-a3.e953aa90.png";